import { css } from "emotion";

import { colors, fonts, icons } from "@cobliteam/base-components/src/styles";

export const tooltip = css`
  width: 215px;

  > :last-child {
    margin-top: 10px;
  }
`;

export const listItemWrapper = css`
  margin: 0;
  padding: 0;
`;

export const title = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 30px;
  white-space: nowrap;
`;

export const wrapperRouteName = css`
  margin-left: 40px;
  text-overflow: ellipsis;
  overflow: hidden;
`;

export const routeName = css`
  font-weight: ${fonts.weight.bold};
`;

export const dividerWrapper = css`
  && {
    margin: 10px 0 20px;
  }
`;

export const incompletedBanner = css`
  padding: 15px 20px 20px;
  border-radius: 5px;
  background-color: ${colors.shadows.getShadow(colors.primary.default, 0.05)};
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const bannerText = css`
  color: ${colors.gray.dark};
`;

export const learnMoreButton = css`
  && {
    color: ${colors.primary.default};
  }
  font-weight: ${fonts.weight.bold};

  :visited {
    color: ${colors.primary.default};
  }

  :hover {
    color: ${colors.primary.hover};
  }
`;

export const disable = css`
  opacity: 0.5;
`;

export const cardContainer = css`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 25px 20px 15px;
  border: 1px solid ${colors.gray.light};
  box-sizing: border-box;
  border-radius: 5px;
  margin-top: 20px;
`;

export const onlineIcon = css`
  display: flex;
  width: ${icons.size.smallest};
  height: ${icons.size.smallest};
  color: ${colors.primary.default};
`;

export const listItem = css`
  display: flex;
  flex-direction: column;
`;
